import request from './request'

export const getArticleCategoryList = (params) => {
  return request({
    url: '/admin/article-categories',
    method: 'get',
    params
  })
}

export const getArticleCategoryDetail = (id) => {
  return request({
    url: `/admin/article-categories/${id}`,
    method: 'get'
  })
}

export const createArticleCategory = (data) => {
  return request({
    url: '/admin/article-categories',
    method: 'post',
    data
  })
}

export const updateArticleCategory = (id, data) => {
  return request({
    url: `/admin/article-categories/${id}`,
    method: 'put',
    data
  })
}

export const deleteArticleCategory = (id) => {
  return request({
    url: `/admin/article-categories/${id}`,
    method: 'delete'
  })
}

export const getArticleList = (params) => {
  return request({
    url: '/admin/articles',
    method: 'get',
    params
  })
}

export const getArticleDetail = (id) => {
  return request({
    url: `/admin/articles/${id}`,
    method: 'get'
  })
}

export const createArticle = (data) => {
  return request({
    url: '/admin/articles',
    method: 'post',
    data
  })
}

export const updateArticle = (id, data) => {
  return request({
    url: `/admin/articles/${id}`,
    method: 'put',
    data
  })
}

export const deleteArticle = (id) => {
  return request({
    url: `/admin/articles/${id}`,
    method: 'delete'
  })
}